<template>
    <div>

    <div class="question">
        <h2>Veelgestelde vragen</h2>
        <div class="question-accordion">
            <HomeQuestionAccordion >
                <h3 slot="title">Onze tevredenheidsgarantie</h3>
                <p slot="description">Het heeft geen zin om tegen je zin lid te blijven van Testaankoop. Dankzij onze tevredenheidsgarantie ben je vrij om je abonnement stop te zetten wanneer je dat wenst. Je verwittigt ons ten laatste 15 werkdagen voor het einde van elke maandelijkse vervaldag*. Er is dus geen enkele aankoopverplichting en je bent ons geen verklaring verschuldigd.</p>
                <p slot="description">*Opgelet: elke begonnen maand wordt beschouwd als een volledige maand.</p>
            </HomeQuestionAccordion>
            <HomeQuestionAccordion >
                <h3 slot="title">Wat gebeurt er na mijn proefperiode?</h3>
                <p  slot="description">Als je wilt blijven profiteren van alle voordelen en diensten van Testaankoop na je proefperiode, hoef je niets te doen. Je geniet een exclusieve korting van 50% tot het einde van het eerste abonnementsjaar en betaalt slechts € 12,33 per maand in plaats van € 24,66. Dat is weinig, in vergelijking met de honderden euro's die je dankzij Testaankoop bespaart.</p>
                <p  slot="description">Je kunt je abonnement eenvoudig opzeggen door ons te bellen op 02 891 37 00 of <span @click.prevent="openInfosModal('contact')">ons contactformulier</span> in te vullen.</p>

            </HomeQuestionAccordion>

        </div>
        <div class="question-desktop-container">

        <div class="question-container">
            <h3>Onze tevredenheidsgarantie</h3>
            <p>Het heeft geen zin om tegen je zin lid te blijven van Test Aankoop. Dankzij onze tevredenheidsgarantie ben je vrij om je abonnement stop te zetten wanneer je dat wenst. Je verwittigt ons ten laatste 15 werkdagen voor het einde van elke maandelijkse vervaldag*. Er is dus geen enkele aankoopverplichting en je bent ons geen verklaring verschuldigd.</p>
            <p>*Opgelet: elke begonnen maand wordt beschouwd als een volledige maand.</p>
        </div>
        <div class="question-container">
            <h3>Wat gebeurt er na mijn proefperiode?</h3>
            <p>Als je wilt blijven profiteren van alle voordelen en diensten van Testaankoop na je proefperiode, hoef je niets te doen. Je geniet een exclusieve korting van 50% tot het einde van het eerste abonnementsjaar en betaalt slechts € 12,33 per maand in plaats van € 24,66. Dat is weinig, in vergelijking met de honderden euro's die je dankzij Testaankoop bespaart.</p>
            <p>Je kunt je abonnement eenvoudig opzeggen door ons te bellen op 02 891 37 00 of <span @click.prevent="openInfosModal('contact')">ons contactformulier</span> in te vullen.</p>
        </div>
    </div>
        <div class="link-container">
            <a @click.prevent="openInfosModal('faq')">Meer lezen</a>
        </div>
    </div>
    </div>

</template>

<script>
import InfosModal from "../../modals/InfosModal";
import HomeQuestionAccordion from './HomeQuestionAccordion.vue';

export default {
    components: { HomeQuestionAccordion },
    name: "HomeQuestion",
    methods:{
        openInfosModal(tab) {
            this.$buefy.modal.open({
                component: InfosModal,
                props: {
                    activeTab: tab
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
